/**
 * @format
 * @module ui/dsw-pencil
 */
import tgamConfig from "config/tgam";
import { isSubscribed, isOnDemand } from "lib/identity/api";
import { qs, getProp } from "utils/utils";
import {
  isFreeToViewReferrer,
  isFullChartPage,
  isElectionPage
} from "lib/commercial/keytar/helpers";
import values from "lodash/values";
import logger from "utils/logger";

const debugTag = "[DSW-PENCIL]";

/**
 * Init the pencil banner from DSW
 */
export function initPencilBanner() {
  const pencilEnabled = getProp(tgamConfig, "env.pencilEnabled", "false") === "true";
  const isAdv = getProp(tgamConfig, "meta.advContent", false);
  const conditions = {
    isNotSubscriber: !isSubscribed(),
    isNotOnDemand: !isOnDemand(),
    isNotElectionPage: !isElectionPage(tgamConfig), // Election 2021: Hide on related pages and templates (when active)
    isNotAppView: !tgamConfig.env.inAppView,
    isNotPbAdmin: !tgamConfig.env.isPbAdmin,
    isNotFullChartPage: !isFullChartPage(),
    isNotFreeToViewReferrer: !isFreeToViewReferrer(),
    pencilEnabled: pencilEnabled,
    isNotAdv: !isAdv
  };
  logger.info(`${debugTag} loadPencilModules()`, conditions);

  if (values(conditions).every(cond => cond === true)) {
    displayPencilBanner();
  }
}

/**
 * Displays the pencil banner from DSW
 */
function displayPencilBanner() {
  logger.info(`${debugTag} initDSWPencil`);
  // Pencil is fetched and printed in header server-side only if API responds with "Y" (Yes)
  const dswPencil = qs(".js-dsw-pencil");
  if (!dswPencil) {
    return;
  }

  // Add CSS to the head
  const pencilCSS = getProp(window, "tgam.dswPencil.css", ""); // String
  const wrapper = document.createElement("div");
  wrapper.innerHTML = pencilCSS;
  const link = wrapper.firstChild;
  document.head.appendChild(link);

  // Add markup to the body
  document.body.appendChild(dswPencil);

  // Add Javascript to the body
  const pencilJS = qs(".js-dsw-pencil-javacript");
  if (!pencilJS) {
    return;
  }
  const pencilJSContent = pencilJS.textContent;
  pencilJS.parentElement.removeChild(pencilJS);

  const scriptElement = document.createElement("script");
  scriptElement.type = "text/javascript";
  scriptElement.id = "dsw-pencil";
  scriptElement.text = `(function initDSWPencil() {
    ${pencilJSContent}
  })();`;
  document.body.appendChild(scriptElement);

  // Reveal the pencil
  dswPencil.classList.remove("u-hidden");
  document.body.classList.add("body--pencil-present");
}
